import tw from 'twin.macro';
import ChevronSvg from '../../../static/images/chevron-up.svg';

export const Chevron = tw(ChevronSvg)`w-[14px] fill-neutrals-n7`;
